module.exports = __webpack_public_path__ + "img/MTCIFERB.185f6e55.svg";